module.exports = __webpack_public_path__ + "static/media/slider_4_collab_user_en.7b870e52.svg";